import { render, staticRenderFns } from "./AccountableAssets.vue?vue&type=template&id=22365f08"
import script from "./AccountableAssets.vue?vue&type=script&lang=js"
export * from "./AccountableAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports